// import React, { useEffect, useState } from "react";
// import { Table, Button, Form, InputGroup, Pagination, Badge, Spinner, Modal, Card } from "react-bootstrap";
// import api from "../../api";
// import Can from "../../components/Can";
// import ManualScoringPanel from "../../components/forms/ManualScoringPanel";
// import FormSectionScoreBreakdown from "../../components/forms/FormSectionScoreBreakdown";
// import FormFieldScoreBreakdown from "../../components/forms/FormFieldScoreBreakdown";
// import FormReviewTimeline from "../../components/forms/FormReviewTimeline";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./FormReviewQueuePage.css";

// // Phase 3C, §29. No separate UAT review page — UAT is just a form_type,
// // reviewed through this exact same queue as any other scored form.
// const STATUS_TABS = [
//   { key: "", label: "All Pending" },
//   { key: "pending_review", label: "Pending Review" },
//   { key: "pending_approval", label: "Pending Approval" },
// ];

// export default function FormReviewQueuePage() {
//   const [rows, setRows] = useState([]);
//   const [total, setTotal] = useState(0);
//   const [loading, setLoading] = useState(false);

//   const [statusTab, setStatusTab] = useState("");
//   const [formTypeFilter, setFormTypeFilter] = useState("");
//   const [projectFilter, setProjectFilter] = useState("");
//   const [search, setSearch] = useState("");
//   const [formTypes, setFormTypes] = useState([]);
//   const [projects, setProjects] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const pageSize = 20;

//   const [detail, setDetail] = useState(null); // the selected queue row
//   const [loadingDetail, setLoadingDetail] = useState(false);
//   const [manualScores, setManualScores] = useState([]);
//   const [sectionScores, setSectionScores] = useState([]);
//   const [fieldScores, setFieldScores] = useState([]);
//   const [reviewStages, setReviewStages] = useState([]);
//   const [savingManual, setSavingManual] = useState(false);

//   const [confirmAction, setConfirmAction] = useState(null); // "APPROVE" | "REJECT" | "CHANGES_REQUESTED"
//   const [remarks, setRemarks] = useState("");
//   const [decidingStageId, setDecidingStageId] = useState(null);
//   const [submittingDecision, setSubmittingDecision] = useState(false);

//   useEffect(() => {
//     fetchQueue();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [statusTab, formTypeFilter, projectFilter, search, currentPage]);

//   useEffect(() => {
//     Promise.all([
//       api.get("/form-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//       api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
//     ]).then(([typeRes, projectRes]) => {
//       setFormTypes(Array.isArray(typeRes?.data?.data) ? typeRes.data.data : []);
//       setProjects(Array.isArray(projectRes?.data?.data) ? projectRes.data.data : []);
//     });
//   }, []);

//   const fetchQueue = async () => {
//     try {
//       setLoading(true);
//       const res = await api.get("/my-form-review-queue", {
//         params: {
//           status: statusTab || undefined,
//           form_type_id: formTypeFilter || undefined,
//           project_id: projectFilter || undefined,
//           search: search || undefined,
//           page: currentPage,
//           pageSize,
//         },
//       });
//       setRows(Array.isArray(res.data?.data) ? res.data.data : []);
//       setTotal(res.data?.meta?.total || 0);
//     } catch (err) {
//       console.error("Fetch review queue error:", err);
//       toast.error(err.response?.data?.message || "Failed to fetch the review queue");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const totalPages = Math.max(Math.ceil(total / pageSize), 1);

//   const openDetail = async (row) => {
//     setDetail(row);
//     setLoadingDetail(true);
//     try {
//       const submissionId = row.form_submission_id;
//       const [manualRes, sectionRes, fieldRes, stagesRes] = await Promise.all([
//         api.get(`/form-submissions/${submissionId}/manual-scores`).catch(() => ({ data: { data: [] } })),
//         api.get(`/form-submissions/${submissionId}/result/sections`).catch(() => ({ data: { data: [] } })),
//         api.get(`/form-submissions/${submissionId}/result/fields`).catch(() => ({ data: { data: [] } })),
//         api.get(`/form-submissions/${submissionId}/review-stages`).catch(() => ({ data: { data: [] } })),
//       ]);
//       setManualScores(manualRes.data?.data || []);
//       setSectionScores(sectionRes.data?.data || []);
//       setFieldScores(fieldRes.data?.data || []);
//       setReviewStages(stagesRes.data?.data || []);
//     } catch (err) {
//       toast.error("Failed to load submission detail");
//     } finally {
//       setLoadingDetail(false);
//     }
//   };

//   const closeDetail = () => {
//     setDetail(null);
//     setManualScores([]);
//     setSectionScores([]);
//     setFieldScores([]);
//     setReviewStages([]);
//   };

//   const saveManualScores = async (payload) => {
//     if (!detail) return;
//     setSavingManual(true);
//     try {
//       await api.put(`/form-submissions/${detail.form_submission_id}/manual-scores`, payload);
//       toast.success("Manual scores saved");
//       await openDetail(detail);
//     } catch (err) {
//       const data = err.response?.data;
//       toast.error(data?.message || "Failed to save manual scores");
//     } finally {
//       setSavingManual(false);
//     }
//   };

//   const currentPendingStage = () => (reviewStages || []).find((s) => s.status === "PENDING");

//   const openConfirm = (action) => {
//     const stage = currentPendingStage();
//     if (!stage) {
//       toast.warning("There is no pending review/approval stage for this submission.");
//       return;
//     }
//     setDecidingStageId(stage.id);
//     setConfirmAction(action);
//     setRemarks("");
//   };

//   const submitDecision = async () => {
//     if (!detail || !decidingStageId) return;
//     setSubmittingDecision(true);
//     try {
//       await api.post(`/form-submissions/${detail.form_submission_id}/review-stages/${decidingStageId}/decision`, {
//         action: confirmAction,
//         remarks: remarks || undefined,
//       });
//       toast.success(`Decision recorded: ${confirmAction}`);
//       setConfirmAction(null);
//       await openDetail(detail);
//       fetchQueue();
//     } catch (err) {
//       const data = err.response?.data;
//       if (data?.code === "FORM_REVIEW_REMARK_REQUIRED") {
//         toast.error("Remarks are required for this decision.");
//       } else if (data?.code === "FORM_REVIEW_STAGE_STALE") {
//         toast.error("This stage has already been decided.");
//       } else if (data?.code === "FORM_REVIEW_SEQUENCE_INVALID") {
//         toast.error("The review stage must be completed before approval.");
//       } else {
//         toast.error(data?.message || "Failed to record decision");
//       }
//     } finally {
//       setSubmittingDecision(false);
//     }
//   };

//   return (
//     <div className="unit-page reviewqueue-theme">
//       <ToastContainer position="top-right" autoClose={3000} />

//       <div className="unit-header">
//         <div>
//           <div className="unit-page-label">Forms</div>
//           <h2>Form Review Queue</h2>
//           <p>Submissions awaiting your review or approval — enter manual scores, review the breakdown, and record a decision.</p>
//         </div>
//         <div className="unit-header-actions">
//           <Button className="unit-btn unit-btn-light" onClick={fetchQueue}>
//             <i className="fa-solid fa-rotate" aria-hidden="true"></i>
//             Refresh
//           </Button>
//         </div>
//       </div>

//       <div className="unit-card">
//         <div className="unit-toolbar">
//           <div className="unit-tabs">
//             {STATUS_TABS.map((t) => (
//               <Button
//                 key={t.key}
//                 size="sm"
//                 variant={statusTab === t.key ? "primary" : "outline-secondary"}
//                 className={`unit-tab${statusTab === t.key ? " unit-tab-active" : ""}`}
//                 onClick={() => { setCurrentPage(1); setStatusTab(t.key); }}
//               >
//                 {t.label}
//               </Button>
//             ))}
//           </div>
//           <div className="unit-toolbar-actions">
//             <InputGroup className="unit-search">
//               <InputGroup.Text aria-hidden="true">
//                 <i className="fa-solid fa-magnifying-glass"></i>
//               </InputGroup.Text>
//               <Form.Control
//                 placeholder="Search..."
//                 aria-label="Search review queue"
//                 value={search}
//                 onChange={(e) => { setCurrentPage(1); setSearch(e.target.value); }}
//               />
//             </InputGroup>
//             <Form.Select style={{ maxWidth: 170 }} value={formTypeFilter} onChange={(e) => { setCurrentPage(1); setFormTypeFilter(e.target.value); }}>
//               <option value="">All Form Types</option>
//               {formTypes.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
//             </Form.Select>
//             <Form.Select style={{ maxWidth: 170 }} value={projectFilter} onChange={(e) => { setCurrentPage(1); setProjectFilter(e.target.value); }}>
//               <option value="">All Projects</option>
//               {projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
//             </Form.Select>
//           </div>
//         </div>

//         <div className="unit-table-wrapper">
//           {loading ? (
//             <div className="unit-loader"><Spinner animation="border" /><p>Loading review queue...</p></div>
//           ) : (
//             <Table responsive className="unit-table">
//               <thead>
//                 <tr>
//                   <th>Form</th>
//                   <th>Submitted By</th>
//                   <th>Scope</th>
//                   <th>Submitted</th>
//                   <th>Stage</th>
//                   <th>Provisional Result</th>
//                   <th className="text-end">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {rows.length > 0 ? rows.map((row) => (
//                   <tr key={row.review_stage_id}>
//                     <td>
//                       <strong>{row.form_name}</strong> <span className="text-muted small">v{row.version_number}</span><br />
//                       <Badge bg="light" text="dark">{row.form_type_name}</Badge>
//                     </td>
//                     <td className="small">{row.submitted_by_name}</td>
//                     <td className="small text-muted">{row.project_name || "—"}{row.project_module_name ? ` / ${row.project_module_name}` : ""}</td>
//                     <td className="small">{row.submitted_at ? new Date(row.submitted_at).toLocaleString() : "—"}</td>
//                     <td><Badge bg="warning" text="dark">{row.stage_type}</Badge></td>
//                     <td className="small">{row.percentage != null ? `${row.percentage}%` : "—"} {row.grade ? `(${row.grade})` : ""}</td>
//                     <td className="text-end">
//                       <Button
//                         size="sm"
//                         variant="outline-primary"
//                         className="rq-open-btn"
//                         onClick={() => openDetail(row)}
//                         aria-label={`Open ${row.form_name || "submission"} for review`}
//                       >
//                         <i className="fa-solid fa-clipboard-check" aria-hidden="true"></i>
//                         Open
//                       </Button>
//                     </td>
//                   </tr>
//                 )) : (
//                   <tr>
//                     <td colSpan="7">
//                       <div className="unit-empty">
//                         <div className="unit-empty-icon">
//                           <i className="fa-solid fa-inbox" aria-hidden="true"></i>
//                         </div>
//                         <h5>Nothing awaiting your review</h5>
//                         <p>Your review queue is empty for the selected filters.</p>
//                       </div>
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           )}
//         </div>

//         <div className="unit-footer">
//           <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> item(s)</div>
//           {totalPages > 1 && (
//             <Pagination className="unit-pagination">
//               <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
//               {[...Array(totalPages)].map((_, i) => (
//                 <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
//               ))}
//               <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
//             </Pagination>
//           )}
//         </div>
//       </div>

//       <Modal
//         show={!!detail}
//         onHide={closeDetail}
//         centered
//         size="xl"
//         className="unit-modal rq-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-xl"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <i className="fa-solid fa-clipboard-check modal-header-icon" aria-hidden="true"></i>
//             <Modal.Title>{detail?.form_name} — {detail?.submitted_by_name}</Modal.Title>
//           </div>
//         </Modal.Header>
//         <Modal.Body>
//           {loadingDetail ? (
//             <div className="unit-loader"><Spinner animation="border" /></div>
//           ) : (
//             <>
//               <Card className="mb-3 rq-modal-card">
//                 <Card.Body>
//                   <strong className="small d-block mb-2">Section Breakdown</strong>
//                   <FormSectionScoreBreakdown sections={sectionScores} />
//                   <strong className="small d-block mt-3 mb-2">Field Breakdown</strong>
//                   <FormFieldScoreBreakdown fields={fieldScores} />
//                 </Card.Body>
//               </Card>

//               <Card className="mb-3 rq-modal-card">
//                 <Card.Body>
//                   <strong className="small d-block mb-2">Manual Scoring</strong>
//                   <ManualScoringPanel scores={manualScores} onSave={saveManualScores} saving={savingManual} />
//                 </Card.Body>
//               </Card>

//               <Card className="rq-modal-card">
//                 <Card.Body>
//                   <strong className="small d-block mb-2">Review Timeline</strong>
//                   <FormReviewTimeline stages={reviewStages} />
//                 </Card.Body>
//               </Card>
//             </>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={closeDetail}>Close</Button>
//           <Can moduleKey="form_reviews" actionKey="request_changes">
//             <Button variant="outline-warning" onClick={() => openConfirm("CHANGES_REQUESTED")}>
//               <i className="fa-solid fa-arrow-rotate-left" aria-hidden="true"></i>
//               Request Changes
//             </Button>
//           </Can>
//           <Can moduleKey="form_reviews" actionKey="reject">
//             <Button variant="outline-danger" onClick={() => openConfirm("REJECT")}>
//               <i className="fa-solid fa-circle-xmark" aria-hidden="true"></i>
//               Reject
//             </Button>
//           </Can>
//           <Can moduleKey="form_reviews" actionKey="approve">
//             <Button variant="success" onClick={() => openConfirm("APPROVE")}>
//               <i className="fa-solid fa-circle-check" aria-hidden="true"></i>
//               Approve
//             </Button>
//           </Can>
//         </Modal.Footer>
//       </Modal>

//       <Modal
//         show={!!confirmAction}
//         onHide={() => setConfirmAction(null)}
//         centered
//         className="unit-modal rq-modal"
//         dialogClassName="admin-teal-modal admin-teal-modal-sm"
//         backdropClassName="admin-teal-backdrop"
//       >
//         <Modal.Header closeButton closeLabel="Close">
//           <div className="d-flex align-items-center">
//             <i className="fa-solid fa-circle-question modal-header-icon" aria-hidden="true"></i>
//             <Modal.Title>Confirm: {confirmAction}</Modal.Title>
//           </div>
//         </Modal.Header>
//         <Modal.Body>
//           <p>Are you sure you want to record this decision?</p>
//           <Form.Label>Remarks {(confirmAction === "REJECT" || confirmAction === "CHANGES_REQUESTED") && <span className="text-danger">*</span>}</Form.Label>
//           <Form.Control as="textarea" rows={3} value={remarks} onChange={(e) => setRemarks(e.target.value)} placeholder="Optional for approval, required for reject/changes requested" />
//         </Modal.Body>
//         <Modal.Footer>
//           <Button className="unit-btn unit-btn-light" onClick={() => setConfirmAction(null)}>Cancel</Button>
//           <Button variant="primary" disabled={submittingDecision} onClick={submitDecision}>
//             {submittingDecision ? (
//               "Submitting..."
//             ) : (
//               <>
//                 <i className="fa-solid fa-check" aria-hidden="true"></i>
//                 Confirm
//               </>
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }



import React, { useEffect, useState } from "react";
import { compactPageItems } from "../../components/ui/compactPagination";
import { Table, Button, Form, InputGroup, Pagination, Spinner, Modal, Card } from "react-bootstrap";
import api from "../../api";
import Can from "../../components/Can";
import ManualScoringPanel from "../../components/forms/ManualScoringPanel";
import DynamicFormRenderer from "../../components/forms/DynamicFormRenderer";
import FormSectionScoreBreakdown from "../../components/forms/FormSectionScoreBreakdown";
import FormFieldScoreBreakdown from "../../components/forms/FormFieldScoreBreakdown";
import FormReviewTimeline from "../../components/forms/FormReviewTimeline";
import ExternalRecipientBadge, { isExternalRecipient } from "../../components/forms/ExternalRecipientBadge";
import { toast } from "react-toastify";
import { initialsOf, avatarColorFor } from "../../utils/avatar";
import { viewAuthenticatedFileInNewTab, getFileAccessErrorMessage } from "../../utils/fileAccess";
import "./FormReviewQueuePage.css";

// Phase 3C, §29. No separate UAT review page — UAT is just a form_type,
// reviewed through this exact same queue as any other scored form.
const STATUS_TABS = [
  { key: "", label: "All Pending" },
  { key: "pending_review", label: "Pending Review" },
  { key: "pending_approval", label: "Pending Approval" },
];

// Forms Workspace redesign: a compact review-status pill computed from
// REAL fields only (rs.status, rs.due_at) -- never a fabricated "In
// Review" state, since form_submission_review_stages.status only has
// PENDING/APPROVED/REJECTED/CHANGES_REQUESTED. A pending stage past its
// due_at shows as Overdue; otherwise it's labeled by its real stage_type.
function reviewStatusInfo(row) {
  if (row.stage_status === "APPROVED") return { label: "Approved", tone: "success" };
  if (row.stage_status === "REJECTED") return { label: "Rejected", tone: "danger" };
  if (row.stage_status === "CHANGES_REQUESTED") return { label: "Changes Requested", tone: "warning" };
  if (row.due_at && new Date(row.due_at) < new Date()) return { label: "Overdue", tone: "danger" };
  return { label: row.stage_type === "APPROVAL" ? "Pending Approval" : "Pending Review", tone: "info" };
}

export default function FormReviewQueuePage({ embedded = false } = {}) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const [statusTab, setStatusTab] = useState("");
  const [formTypeFilter, setFormTypeFilter] = useState("");
  const [projectFilter, setProjectFilter] = useState("");
  const [search, setSearch] = useState("");
  const [formTypes, setFormTypes] = useState([]);
  const [projects, setProjects] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 20;

  const [detail, setDetail] = useState(null); // the selected queue row
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [runtime, setRuntime] = useState(null);
  const [manualScores, setManualScores] = useState([]);
  const [sectionScores, setSectionScores] = useState([]);
  const [fieldScores, setFieldScores] = useState([]);
  const [reviewStages, setReviewStages] = useState([]);
  const [savingManual, setSavingManual] = useState(false);

  const [confirmAction, setConfirmAction] = useState(null); // "APPROVE" | "REJECT" | "CHANGES_REQUESTED"
  const [remarks, setRemarks] = useState("");
  const [decidingStageId, setDecidingStageId] = useState(null);
  const [submittingDecision, setSubmittingDecision] = useState(false);

  useEffect(() => {
    fetchQueue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusTab, formTypeFilter, projectFilter, search, currentPage]);

  useEffect(() => {
    Promise.all([
      api.get("/form-types", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
      api.get("/projects", { params: { is_active: 1, pageSize: 200 } }).catch(() => null),
    ]).then(([typeRes, projectRes]) => {
      setFormTypes(Array.isArray(typeRes?.data?.data) ? typeRes.data.data : []);
      setProjects(Array.isArray(projectRes?.data?.data) ? projectRes.data.data : []);
    });
  }, []);

  const fetchQueue = async () => {
    try {
      setLoading(true);
      const res = await api.get("/my-form-review-queue", {
        params: {
          status: statusTab || undefined,
          form_type_id: formTypeFilter || undefined,
          project_id: projectFilter || undefined,
          search: search || undefined,
          page: currentPage,
          pageSize,
        },
      });
      setRows(Array.isArray(res.data?.data) ? res.data.data : []);
      setTotal(res.data?.meta?.total || 0);
    } catch (err) {
      console.error("Fetch review queue error:", err);
      toast.error(err.response?.data?.message || "Failed to fetch the review queue");
    } finally {
      setLoading(false);
    }
  };

  const totalPages = Math.max(Math.ceil(total / pageSize), 1);

  const openDetail = async (row) => {
    setDetail(row);
    setLoadingDetail(true);
    try {
      const submissionId = row.form_submission_id;
      const [manualRes, sectionRes, fieldRes, stagesRes, runtimeRes] = await Promise.all([
        api.get(`/form-submissions/${submissionId}/manual-scores`).catch(() => ({ data: { data: [] } })),
        api.get(`/form-submissions/${submissionId}/result/sections`).catch(() => ({ data: { data: [] } })),
        api.get(`/form-submissions/${submissionId}/result/fields`).catch(() => ({ data: { data: [] } })),
        api.get(`/form-submissions/${submissionId}/review-stages`).catch(() => ({ data: { data: [] } })),
        // Dynamic Forms visibility audit, §7: a reviewer must never decide
        // blind -- previously this modal showed only scores/manual-scoring/
        // timeline, never the actual submitted answers. Tolerates its own
        // failure (e.g. an edge case with no matching review stage) without
        // blocking the score/timeline panels above from still rendering.
        api.get(`/form-submissions/${submissionId}/runtime`).catch(() => ({ data: { data: null } })),
      ]);
      setManualScores(manualRes.data?.data || []);
      setSectionScores(sectionRes.data?.data || []);
      setFieldScores(fieldRes.data?.data || []);
      setReviewStages(stagesRes.data?.data || []);
      setRuntime(runtimeRes.data?.data || null);
    } catch (err) {
      toast.error("Failed to load submission detail");
    } finally {
      setLoadingDetail(false);
    }
  };

  const closeDetail = () => {
    setDetail(null);
    setManualScores([]);
    setSectionScores([]);
    setFieldScores([]);
    setReviewStages([]);
    setRuntime(null);
  };

  const handleViewFile = async (submissionId, file) => {
    try {
      await viewAuthenticatedFileInNewTab(`/form-submissions/${submissionId}/files/${file.id}/view`);
    } catch (err) {
      toast.error(getFileAccessErrorMessage(err));
    }
  };

  const saveManualScores = async (payload) => {
    if (!detail) return;
    setSavingManual(true);
    try {
      await api.put(`/form-submissions/${detail.form_submission_id}/manual-scores`, payload);
      toast.success("Manual scores saved");
      await openDetail(detail);
    } catch (err) {
      const data = err.response?.data;
      toast.error(data?.message || "Failed to save manual scores");
    } finally {
      setSavingManual(false);
    }
  };

  const currentPendingStage = () => (reviewStages || []).find((s) => s.status === "PENDING");

  const openConfirm = (action) => {
    const stage = currentPendingStage();
    if (!stage) {
      toast.warning("There is no pending review/approval stage for this submission.");
      return;
    }
    setDecidingStageId(stage.id);
    setConfirmAction(action);
    setRemarks("");
  };

  const submitDecision = async () => {
    if (!detail || !decidingStageId) return;
    setSubmittingDecision(true);
    try {
      await api.post(`/form-submissions/${detail.form_submission_id}/review-stages/${decidingStageId}/decision`, {
        action: confirmAction,
        remarks: remarks || undefined,
      });
      toast.success(`Decision recorded: ${confirmAction}`);
      setConfirmAction(null);
      await openDetail(detail);
      fetchQueue();
    } catch (err) {
      const data = err.response?.data;
      if (data?.code === "FORM_REVIEW_REMARK_REQUIRED") {
        toast.error("Remarks are required for this decision.");
      } else if (data?.code === "FORM_REVIEW_STAGE_STALE") {
        toast.error("This stage has already been decided.");
      } else if (data?.code === "FORM_REVIEW_SEQUENCE_INVALID") {
        toast.error("The review stage must be completed before approval.");
      } else {
        toast.error(data?.message || "Failed to record decision");
      }
    } finally {
      setSubmittingDecision(false);
    }
  };

  return (
    <div className={`unit-page reviewqueue-theme ${embedded ? "fa-embedded" : ""}`}>

      <div className="unit-header">
        {!embedded && (
          <div>
            <div className="unit-page-label">Forms</div>
            <h2>Form Review Queue</h2>
            <p>Submissions awaiting your review or approval — enter manual scores, review the breakdown, and record a decision.</p>
          </div>
        )}
        <div className="unit-header-actions">
          <Button className="unit-btn unit-btn-light" onClick={fetchQueue}>
            <i className="fa-solid fa-rotate" aria-hidden="true"></i>
            Refresh
          </Button>
        </div>
      </div>

      <div className="unit-stats-row">
        <div className="unit-stat-card reviewqueue-stat-blue">
          <div className="reviewqueue-stat-content">
            <div className="reviewqueue-stat-text">
              <span>Total Queue Items</span>
              <strong>{total}</strong>
            </div>

            <div className="reviewqueue-stat-icon">
              <i className="fa-solid fa-inbox" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card reviewqueue-stat-purple">
          <div className="reviewqueue-stat-content">
            <div className="reviewqueue-stat-text">
              <span>Current Page</span>
              <strong>{currentPage}</strong>
            </div>

            <div className="reviewqueue-stat-icon">
              <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
            </div>
          </div>
        </div>

        <div className="unit-stat-card reviewqueue-stat-green">
          <div className="reviewqueue-stat-content">
            <div className="reviewqueue-stat-text">
              <span>Rows Per Page</span>
              <strong>{pageSize}</strong>
            </div>

            <div className="reviewqueue-stat-icon">
              <i className="fa-solid fa-table-list" aria-hidden="true"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="unit-card">
        <div className="unit-toolbar reviewqueue-toolbar">
          <div className="reviewqueue-section-top">
            <div className="reviewqueue-section-title">
              <div className="reviewqueue-section-icon">
                <i className="fa-solid fa-list-check" aria-hidden="true"></i>
              </div>

              <div className="reviewqueue-section-copy">
                <h5>Review Queue</h5>
                <p>
                  Review submitted forms, complete manual scoring, and record the
                  required stage decision.
                </p>
              </div>
            </div>

            <div className="unit-tabs reviewqueue-tabs">
              {STATUS_TABS.map((t) => (
                <Button
                  key={t.key}
                  className={`reviewqueue-tab${
                    statusTab === t.key ? " reviewqueue-tab-active" : ""
                  }`}
                  onClick={() => {
                    setCurrentPage(1);
                    setStatusTab(t.key);
                  }}
                >
                  {t.label}
                </Button>
              ))}
            </div>
          </div>

          <div className="unit-toolbar-actions reviewqueue-filters-row">
            <InputGroup className="unit-search reviewqueue-search">
              <InputGroup.Text aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </InputGroup.Text>
              <Form.Control
                placeholder="Search..."
                aria-label="Search review queue"
                value={search}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearch(e.target.value);
                }}
              />

              {search && (
                <Button
                  className="reviewqueue-clear-search"
                  onClick={() => {
                    setCurrentPage(1);
                    setSearch("");
                  }}
                  title="Clear search"
                  aria-label="Clear search"
                >
                  <i className="fa-solid fa-xmark" aria-hidden="true"></i>
                </Button>
              )}
            </InputGroup>
            <div className="reviewqueue-select-wrap">
              <i className="fa-solid fa-shapes reviewqueue-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="reviewqueue-filter-select"
                value={formTypeFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setFormTypeFilter(e.target.value);
                }}
              >
                <option value="">All Form Types</option>
                {formTypes.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.name}
                  </option>
                ))}
              </Form.Select>
            </div>

            <div className="reviewqueue-select-wrap">
              <i className="fa-solid fa-diagram-project reviewqueue-select-icon" aria-hidden="true"></i>
              <Form.Select
                className="reviewqueue-filter-select"
                value={projectFilter}
                onChange={(e) => {
                  setCurrentPage(1);
                  setProjectFilter(e.target.value);
                }}
              >
                <option value="">All Projects</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.name}
                  </option>
                ))}
              </Form.Select>
            </div>
          </div>
        </div>

        <div className="unit-table-wrapper">
          {loading ? (
            <div className="unit-loader"><Spinner animation="border" /><p>Loading review queue...</p></div>
          ) : (
            <Table responsive className="unit-table rq-table-v2">
              <thead>
                <tr>
                  <th>Form</th>
                  <th>Submitted By</th>
                  <th>Assignment</th>
                  <th>Project</th>
                  <th>Submitted</th>
                  <th>Reviewer</th>
                  <th>Review Status</th>
                  <th className="text-end">Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? rows.map((row) => {
                  const info = reviewStatusInfo(row);
                  return (
                    <tr key={row.review_stage_id}>
                      <td>
                        <strong>{row.form_name}</strong>
                        <div className="rq-version-pill">v{row.version_number}</div>
                      </td>
                      <td className="small">
                        <span className="rq-avatar" style={{ background: avatarColorFor(row.submitted_by_name) }}>{initialsOf(row.submitted_by_name)}</span>
                        {row.submitted_by_name || "—"}
                        <ExternalRecipientBadge external={isExternalRecipient(row)} />
                        {/* External respondent (no account): the address it answered from. */}
                        {isExternalRecipient(row) && row.submitted_by_email && row.submitted_by_email !== row.submitted_by_name && (
                          <div className="text-muted small">{row.submitted_by_email}</div>
                        )}
                      </td>
                      <td className="small">{row.assignment_title || "—"}</td>
                      <td className="small rq-scope-cell">{row.project_name || "—"}{row.project_module_name ? ` / ${row.project_module_name}` : ""}</td>
                      <td className="small">{row.submitted_at ? new Date(row.submitted_at).toLocaleDateString() : "—"}</td>
                      <td className="small">
                        {row.reviewer_name ? (
                          <>
                            <span className="rq-avatar" style={{ background: avatarColorFor(row.reviewer_name) }}>{initialsOf(row.reviewer_name)}</span>
                            {row.reviewer_name}
                          </>
                        ) : <span className="text-muted">Unassigned</span>}
                      </td>
                      <td>
                        <span className={`rq-status-pill rq-status-${info.tone}`}><i className="rq-status-dot" aria-hidden="true"></i>{info.label}</span>
                      </td>
                      <td className="text-end">
                        <Button
                          size="sm"
                          className="unit-btn unit-btn-light rq-open-btn"
                          onClick={() => openDetail(row)}
                          aria-label={`Review ${row.form_name || "submission"}`}
                        >
                          Review
                        </Button>
                      </td>
                    </tr>
                  );
                }) : (
                  <tr>
                    <td colSpan="8">
                      <div className="unit-empty">
                        <div className="unit-empty-icon">
                          <i className="fa-solid fa-inbox" aria-hidden="true"></i>
                        </div>
                        <h5>Nothing waiting for action</h5>
                        <p>Your review queue is empty for the selected filters.</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          )}
        </div>

        <div className="unit-footer">
          <div className="unit-count-text">Showing <strong>{rows.length}</strong> of <strong>{total}</strong> item(s)</div>
          {totalPages > 1 && (
            <Pagination className="unit-pagination">
              <Pagination.Prev disabled={currentPage === 1} onClick={() => setCurrentPage((p) => p - 1)} />
              {compactPageItems([...Array(totalPages)].map((_, i) => (
                <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
              )), currentPage)}
              <Pagination.Next disabled={currentPage === totalPages} onClick={() => setCurrentPage((p) => p + 1)} />
            </Pagination>
          )}
        </div>
      </div>

      <Modal
        show={!!detail}
        onHide={closeDetail}
        centered
        size="xl"
        className="unit-modal rq-modal"
        dialogClassName="reviewqueue-admin-modal reviewqueue-admin-modal-xl"
        backdropClassName="reviewqueue-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="reviewqueue-modal-heading">
            <div className="reviewqueue-modal-icon">
              <i className="fa-solid fa-clipboard-check" aria-hidden="true"></i>
            </div>

            <div>
              <small>Submission Review</small>
              <Modal.Title>
                {detail?.form_name} — {detail?.submitted_by_name}
                <ExternalRecipientBadge external={isExternalRecipient(detail)} />
              </Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {loadingDetail ? (
            <div className="unit-loader"><Spinner animation="border" /></div>
          ) : (
            <>
              <Card className="mb-3 rq-modal-card">
                <Card.Body>
                  <div className="reviewqueue-card-title">
                    <i className="fa-solid fa-file-lines" aria-hidden="true"></i>
                    <strong>Response</strong>
                  </div>
                  {runtime ? (
                    <DynamicFormRenderer
                      mode="fill"
                      sections={runtime.structure.sections}
                      values={runtime.valuesByFieldKey}
                      repeatingRowsBySection={runtime.repeatingRowsBySection}
                      filesByFieldKey={runtime.filesByFieldKey}
                      filesByRow={runtime.filesByRow}
                      onViewFile={(file) => handleViewFile(detail.form_submission_id, file)}
                      executionProfile={runtime.execution_profile}
                      readOnly
                    />
                  ) : (
                    <div className="text-muted small">The submitted response could not be loaded.</div>
                  )}
                </Card.Body>
              </Card>

              <Card className="mb-3 rq-modal-card">
                <Card.Body>
                  <div className="reviewqueue-card-title">
                    <i className="fa-solid fa-chart-pie" aria-hidden="true"></i>
                    <strong>Section Breakdown</strong>
                  </div>
                  <FormSectionScoreBreakdown sections={sectionScores} />
                  <div className="reviewqueue-card-title reviewqueue-card-title-spaced">
                    <i className="fa-solid fa-list-check" aria-hidden="true"></i>
                    <strong>Field Breakdown</strong>
                  </div>
                  <FormFieldScoreBreakdown fields={fieldScores} />
                </Card.Body>
              </Card>

              <Card className="mb-3 rq-modal-card">
                <Card.Body>
                  <div className="reviewqueue-card-title">
                    <i className="fa-solid fa-pen-to-square" aria-hidden="true"></i>
                    <strong>Manual Scoring</strong>
                  </div>
                  <ManualScoringPanel scores={manualScores} onSave={saveManualScores} saving={savingManual} />
                </Card.Body>
              </Card>

              <Card className="rq-modal-card">
                <Card.Body>
                  <div className="reviewqueue-card-title">
                    <i className="fa-solid fa-clock-rotate-left" aria-hidden="true"></i>
                    <strong>Review Timeline</strong>
                  </div>
                  <FormReviewTimeline stages={reviewStages} />
                </Card.Body>
              </Card>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="unit-btn unit-btn-light" onClick={closeDetail}>
            <i className="fa-solid fa-xmark" aria-hidden="true"></i>
            Close
          </Button>
          <Can moduleKey="form_reviews" actionKey="request_changes">
            <Button className="reviewqueue-decision-btn reviewqueue-request-btn" onClick={() => openConfirm("CHANGES_REQUESTED")}>
              <i className="fa-solid fa-arrow-rotate-left" aria-hidden="true"></i>
              Request Changes
            </Button>
          </Can>
          <Can moduleKey="form_reviews" actionKey="reject">
            <Button className="reviewqueue-decision-btn reviewqueue-reject-btn" onClick={() => openConfirm("REJECT")}>
              <i className="fa-solid fa-circle-xmark" aria-hidden="true"></i>
              Reject
            </Button>
          </Can>
          <Can moduleKey="form_reviews" actionKey="approve">
            <Button className="reviewqueue-decision-btn reviewqueue-approve-btn" onClick={() => openConfirm("APPROVE")}>
              <i className="fa-solid fa-circle-check" aria-hidden="true"></i>
              Approve
            </Button>
          </Can>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!confirmAction}
        onHide={() => setConfirmAction(null)}
        centered
        className="unit-modal rq-modal"
        dialogClassName="reviewqueue-admin-modal reviewqueue-admin-modal-sm reviewqueue-confirm-modal"
        backdropClassName="reviewqueue-admin-backdrop"
      >
        <Modal.Header closeButton closeLabel="Close">
          <div className="reviewqueue-modal-heading">
            <div className="reviewqueue-modal-icon reviewqueue-modal-icon-question">
              <i className="fa-solid fa-circle-question" aria-hidden="true"></i>
            </div>

            <div>
              <small>Review Decision</small>
              <Modal.Title>
                Confirm: {String(confirmAction || "").replaceAll("_", " ")}
              </Modal.Title>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="reviewqueue-confirm-message">
            <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
            <p>Are you sure you want to record this decision?</p>
          </div>

          <Form.Label>
            Remarks{" "}
            {(confirmAction === "REJECT" ||
              confirmAction === "CHANGES_REQUESTED") && (
              <span className="text-danger">*</span>
            )}
          </Form.Label>

          <Form.Control
            as="textarea"
            rows={3}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            placeholder="Optional for approval, required for reject/changes requested"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="unit-btn unit-btn-light"
            onClick={() => setConfirmAction(null)}
          >
            <i className="fa-solid fa-arrow-left" aria-hidden="true"></i>
            Cancel
          </Button>
          <Button
            className="unit-btn unit-btn-primary"
            disabled={submittingDecision}
            onClick={submitDecision}
          >
            {submittingDecision ? (
              <>
                <Spinner animation="border" size="sm" />
                Submitting...
              </>
            ) : (
              <>
                <i className="fa-solid fa-check" aria-hidden="true"></i>
                Confirm
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
